import React from "react";

import { houseNumberValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function RegistrationHouseNumber(props: {
	labelClassName?: string;
}) {
	const { labelClassName } = props;

	return (
		<FormInputField
			className="form__field"
			name="houseNumber"
			label="registration:HOUSE_NUMBER_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:HOUSE_NUMBER_PLACEHOLDER"
			pattern={{
				value: houseNumberValidationPattern,
				message: "registration:INVALID_HOUSE_NUMBER",
			}}
			required
		/>
	);
}
